import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';

import { TableModule } from 'primeng/table';
import { SliderModule } from 'primeng/slider';
import { DatePickerModule } from 'primeng/datepicker';
//import { Angular2Csv } from 'angular2-csv/Angular2-csv';
import { ngxCsv } from 'ngx-csv/ngx-csv';
import { SelectModule } from 'primeng/select';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { RefundApproveService } from './Service/refund-approve.service';
import { Action, refundApprove, refundApproveReport, refundSubmit } from './Model/refundApprove';
import { authManager } from '@authmanager/authManager';
import { HttpClient } from '@angular/common/http';
import { AdminService } from '@adminservice/admin.service';
import { refundRequestData } from "./Model/refundRequestData";
import { chaseRefundProcessInput } from "./Model/chaseRefundProcessInput";
import { Router } from '@angular/router';
import { CommonModule,DatePipe } from '@angular/common';

@Component({
    selector: 'app-refund-approve',
    templateUrl: './refund-approve.component.html',
    styleUrls: ['./refund-approve.component.css'],
    providers: [RefundApproveService, AdminService],
    standalone: false
})

export class RefundApproveComponent implements OnInit, AfterViewInit {

  action: Action[];
  Action: string;
  previousVal: any;
  currentVal: any;
  RefundApproved: any;
  ApprovalStatus: any;
  comments: any;
  commentstxt: string;
  transID: any;
  transactionID: any;
  refundApprove: refundApprove[] = [];
  updatedINDetails: refundSubmit;
  refundApproveStatus: any;
  UserID: any;
  selectedaction: Action;
  invalidAction: boolean;
  invalidComments: boolean;
  updaterefund: any = {};
  RefundheaderArray: any[] = [];
  agencyTcode: string;

  refundApproveReportList: refundApproveReport[] = [];

  LognewUser: any = {};
  UserLog: string;
  require: any;
  LnewUser: any = {};
  UserLogStatus: any = [];

  selectedItems: any[] = [];
//   RefundFilterFields:any =[
//     'refundDetailID',
// 'orderID',
// 'invoiceID',
// 'transactionID',
// 'orderInvoiceDate',
// 'agency',
// 'advertiser',
// 'refundApproved',
// 'amount',
// 'approvalStatus',
// 'comments',
// 'submittedBy',
// 'updatedDate',
// 'updatedBy',
// 'action',
// 'actionID',
// 'actionType',
// 'invalidAction',
// 'invalidComments',
// 'paymentTransType',
// 'approvalCode',
// 'cmComment',
// 'agencyTcode'
//   ];

  @ViewChild('confirmationModal', { static: false }) confirmationModal: any;

  @ViewChild('dataTable', { static: false }) private refundApproveTable: any;

  constructor(private router: Router, private RefundApproveService: RefundApproveService, private authManagerService: authManager,
    private http: HttpClient, private AdminService: AdminService, public datepipe: DatePipe) {

    //Service call to get the user roles
    this.RefundApproveService.getActionList().subscribe(
      p => this.action = p,
    );

    this.RefundheaderArray = ["Order ID", "Invoice ID", "Invoice Date", "Transaction ID", "Agency","AgencyTcode",
      "Advertiser", "Submitted By", "Amount", "Payment Transaction Type","Approval Code"];

  }

  ngOnInit() {
    this.invalidComments = true;
    this.invalidAction = true;
    this.currentVal = null;
    //Loads the refund details in the grid on page load
    this.UserID = sessionStorage.getItem('userid');
    this.LoadRefundDetails();
    this.saveIP();
  }

  ngAfterViewInit() {
    if (this.refundApproveTable && this.refundApproveTable.filterConstraints) {
      this.refundApproveTable.filterConstraints['inv_invDate'] = (value, filter): boolean => {
        let startDate = new Date(this.datepipe.transform(filter[0], 'yyyy-MM-dd'));
        let endDate = new Date(this.datepipe.transform(filter[1], 'yyyy-MM-dd'));
        let rowDate = new Date(value);
        return (rowDate >= startDate && rowDate <= endDate);
      };
    }
  }

  LoadRefundDetails() {
debugger;
    this.RefundApproveService.getRefundDetails(this.UserID).subscribe(
      p => {
        this.refundApprove = p
      }
    );
  }

  submitAction(updaterefund: refundApprove) {
  debugger;
    if (updaterefund.selectedaction != null) {
      this.Action = updaterefund.selectedaction.actionType;
    }
    else { this.Action = ""; }

    if (this.Action == "") {

      updaterefund.invalidAction = false;
    }
    else {
      updaterefund.invalidAction = true;
    }
    if ((updaterefund.comments == null) || (updaterefund.comments == "")) {

      updaterefund.invalidComments = false;
    }
    else {
      updaterefund.invalidComments = true;
    }

    if (updaterefund.invalidComments == true && updaterefund.invalidAction == true) {

      if (this.Action == "Approve") {
        this.RefundApproved = true;
        this.ApprovalStatus = "Approved";
      }
      else if (this.Action == "Reject") {
        this.RefundApproved = false;
        this.ApprovalStatus = "Rejected";
      }
      else if (this.Action == "Revised") {
        this.RefundApproved = false;
        this.ApprovalStatus = "Revised";
      }


      //this.updatedINDetails.Action = this.Action;

      //this.updatedINDetails.transactionID = updaterefund.transactionID;
     // debugger;
      this.updatedINDetails = new refundSubmit();

      this.updatedINDetails.refundApproved = this.RefundApproved;

      this.updatedINDetails.approvalStatus = this.ApprovalStatus;
      this.updatedINDetails.creditManagerComments = updaterefund.comments;

      this.updatedINDetails.updatedDate = new Date();
      this.updatedINDetails.refundDetailID = updaterefund.refundDetailID;

      //this.updatedINDetails.UpdatedBy = this.authManagerService.dynSSOId;

      this.updatedINDetails.updatedBy = this.UserID;

      //this.updatedINDetails.UpdatedBy = 241000039; // Need to change (uncomment the above line and comment this line)


      this.RefundApproveService.submitActionDetails(this.updatedINDetails).subscribe(
        p => {
          //debugger;
          this.refundApproveStatus = p

          if(this.refundApproveStatus.refundAction == "Approved")
          {
              this.router.navigate(['RefundStatus', this.refundApproveStatus.chaseOrderId]);
          }
          else
          {
            this.LoadRefundDetails();
          }

        }
      );
      

    }
  }

  GenerateRefundXML(requestData: refundRequestData) {
    
    var XMLWriter = require('xml-writer');
    let xw = new XMLWriter();
    xw.startDocument();
    xw.startElement('Request');
    xw.startElement('NewOrder');
    xw.startElement('OrbitalConnectionUsername');
    xw.text('TNBCU9693');
    xw.endElement();
    xw.startElement('OrbitalConnectionPassword');
    xw.text('89Jxbt2x3');
    xw.endElement();
    xw.startElement('IndustryType');
    xw.text('EC');
    xw.endElement();
    xw.startElement('MessageType');
    xw.text('R');
    xw.endElement();
    xw.startElement('BIN');
    xw.text('000001');
    xw.endElement();
    xw.startElement('MerchantID');
    xw.text('349693');
    xw.endElement();
    xw.startElement('TerminalID');
    xw.text('001');
    xw.endElement();
    xw.startElement('AccountNum');
    xw.endElement();
    xw.startElement('Exp');
    xw.endElement();
    xw.startElement('CustomerRefNum');
    xw.text(requestData.customerRefNum);
    xw.endElement();
    xw.startElement('OrderID');
    xw.text(requestData.orderId);
    xw.endElement();
    xw.startElement('Amount');
    xw.text(requestData.amount);
    xw.endElement();
    xw.startElement('TxRefNum');
    xw.text(requestData.transactionRefNum);
    xw.endElement();
    xw.endElement();
    xw.endElement();
    xw.endDocument();

    return xw.toString();

  }


  //Transaction Report Generation
  DownloadRefundDetailReport() {

    this.refundApproveReportList = [];

    //debugger;

    this.refundApprove.forEach(item => {
      let ref = new refundApproveReport();
      ref.orderID = item.orderID;
      ref.invoiceID = item.invoiceID;
      ref.invoiceDate = item.orderInvoiceDate;
      ref.transactionID = item.transactionID;
      ref.agency = item.agency;
      ref.advertiser = item.advertiser;
      ref.submittedBy = item.submittedBy;
      ref.amount = item.amount;

      this.refundApproveReportList.push(ref);
    });


    var options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: true,
      showTitle: true,
      paddingCellOptions: this.paddingCells,
      title: 'MediaPay - Refund Report',
      useBom: true,
      //noDownload: true,
      headers: this.RefundheaderArray
    };
    new ngxCsv(this.refundApproveReportList, 'Refund Report', options);
  }
  public paddingCells: any = {
    background: '#ff0000',
    textAlign: 'center'
  };

  saveIP() {

    this.http.get<{ ip: string }>('https://api.ipify.org?format=json')
      .subscribe(data => {
        this.LognewUser.IPAddress = data.ip;
        this.LognewUser.LoginTime = new Date();
        const { detect } = require('detect-browser');
        const browser = detect();
        this.LognewUser.Browsertype = browser.name;
        this.LognewUser.BrowserVersion = browser.version;
        this.LognewUser.SSO = this.authManagerService.dynSSOId;
        this.LognewUser.FirstName = this.authManagerService.dynFirstName;
        this.LognewUser.LastName = this.authManagerService.dynLastName;
        this.LognewUser.Active = 1;
        this.LognewUser.userID = sessionStorage.getItem('userid');
        this.AdminService.searchUser(this.LognewUser.userID, this.LognewUser.IPAddress, this.LognewUser.Browsertype)
          .subscribe((status) => {
            this.UserLogStatus = status;
            if (this.UserLogStatus == 'Success') {

              this.AdminService.LogNewUserDetails(this.LognewUser)
                .subscribe((status) => { this.UserLogStatus = status; })
            }
            else {
              this.LnewUser.IPAddress = this.LognewUser.IPAddress;
              this.LnewUser.Browsertype = this.LognewUser.Browsertype;
              this.LnewUser.LogOutTime = new Date();
              this.LnewUser.Active = 0;
              this.LnewUser.SSO = this.authManagerService.dynSSOId;
              this.LnewUser.userID = this.LognewUser.userID;
              this.AdminService.LogUserUpdateDetails(this.LnewUser)
                .subscribe((status) => { this.UserLogStatus = status; });

              this.AdminService.LogNewUserDetails(this.LognewUser)
                .subscribe((status) => { this.UserLogStatus = status; })
            }
          });
      }, error =>
          console.error(error));
  }

  //Filter toggle

  enableFilter:boolean=false;
  filterToggle(event) {
    this.enableFilter == false ? this.enableFilter = true : this.enableFilter = false;
    if (!this.enableFilter) {
      this.refundApproveTable.reset();
    }
  }

  GetTransaction() {
    this.router.navigate(['TransactionRefund']);
  }

  onRowRefundUnselect(event: any): void {
    console.log('Row unselected:', event);
    // Add logic here if needed, e.g., deselect form, reset buttons, etc.
  }

  onRefundRowSelect(event: any): void {
    console.log('Row selected:', event);
    // Add logic here if you need to do something when a row is selected
  }

}
